// extracted by mini-css-extract-plugin
export default {"button":"xm-z","reviewSort":"ym-z"};